import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import Feature from 'models/CompetitionMap/Feature';
import { axiosBaseQuery } from 'services/api';

// Tags for cache invalidation
export const FEATURE_TAG = 'Feature';

export const featureApi = createApi({
  reducerPath: 'featureApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/',
  }),
  tagTypes: [FEATURE_TAG],
  endpoints: builder => ({
    // Get list of features
    listFeatures: builder.query({
      query: ({ project, product }) => ({
        url: `projects/${project}/products/${product}/features/`,
      }),
      transformResponse: data => List(data.map(feature => new Feature(feature))),
      providesTags: [FEATURE_TAG],
    }),

    // Fetch single feature
    fetchFeature: builder.query({
      query: ({ project, product, id }) => ({
        url: `projects/${project}/products/${product}/features/${id}/`,
      }),
      transformResponse: data => new Feature(data),
    }),

    // Create feature
    createFeature: builder.mutation({
      query: ({ project, product, ...data }) => ({
        url: `projects/${project}/products/${product}/features/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [FEATURE_TAG],
    }),

    // Update feature
    updateFeature: builder.mutation({
      query: ({ project, product, featureId, ...data }) => ({
        url: `projects/${project}/products/${product}/features/${featureId}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [FEATURE_TAG],
    }),

    // Delete feature
    deleteFeature: builder.mutation({
      query: ({ project, product, featureId }) => ({
        url: `projects/${project}/products/${product}/features/${featureId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [FEATURE_TAG],
    }),
  }),
});

export const {
  useListFeaturesQuery,
  useFetchFeatureQuery,
  useCreateFeatureMutation,
  useUpdateFeatureMutation,
  useDeleteFeatureMutation,
} = featureApi;
